import FactCheckIcon from "@mui/icons-material/FactCheck";
import TimelineIcon from "@mui/icons-material/Timeline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TableCard from "../../components/TableCard";
import { useEffect, useState } from "react";
import {
  buscarSolicitacoesPorStatus,
  buscarTimelineSolicitacao,
} from "../../services/api-planejamento-tributario.service";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import ModalTimeLine from "../../components/ModalTimeline";
import MensagemErro from "../../components/MensagemErro";
import Loading from "../../components/Loading";

const Solicitacoes = () => {
  const [data, setData] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenaModal] = useState(false);
  const [timeline, setTimeline] = useState([]);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await buscarSolicitacoesPorStatus("TODAS");
        setData(handleOrganizaData(response ?? []));
      } catch (error) {
        setMsg(error?.response?.data?.mensagem || error?.message || "Erro ao carregar solicitações.");
        setOpenSnackbarErro(true);
      }
    };
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tipo = urlParams.get("tipo");
    setFiltro(tipo);
    fetchData();
    setLoading(false);
  }, []);

  const handleOpenModal = async (id) => {
    try {
      const response = await buscarTimelineSolicitacao(id);
      setTimeline(Array.isArray(response) ? response : []);
      setOpenaModal(true);
    } catch (error) {
      setMsg(error?.response?.data?.mensagem || error?.message || "Erro ao carregar timeline.");
      setOpenSnackbarErro(true);
    }
  };

  const handleCloseModal = () => {
    setTimeline([]);
    setOpenaModal(false);
  };

  const handleOrganizaData = (response) => {
    const list = Array.isArray(response) ? response : [];
    const newData = list.map((item) => {
      return {
        idSolicitacao: item.idSolicitacao,
        status: item.status
          .toLowerCase()
          .replace(/^\w/, (c) => c.toUpperCase()),
        processo: item.processo,
        botoes: [
          {
            icon: <TimelineIcon />,
            title: "TIMELINE",
            onClick: () => handleOpenModal(item.idSolicitacao),
          },
          {
            icon: <MoreVertIcon />,
            title: "VER DETALHES",
            onClick: () => navigate(item.href),
          },
        ],
      };
    });

    return newData;
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const columns = ["ID", "Status", "Processo"];

  const optionsFilter = [
    { value: "status: Aprovado" },
    { value: "status: Reprovado" },
    { value: "status: Pendente" },
    { value: "status: Criado" },
  ];

  const handlePesquisaPorTexto = () => {};

  return (
    <>
        <TableCard
          iconHeader={
            <FactCheckIcon fontSize="1rem" sx={{ marginRight: "1rem" }} />
          }
          titleHeader="Solicitações"
          optionsFilter={optionsFilter}
          data={data}
          setData={setData}
          columns={columns}
          loading={loading}
          textHeaderCard="idSolicitacao"
          handleDebounce={handlePesquisaPorTexto}
          filterSelected={filtro}
        />
      <ModalTimeLine
        open={openModal}
        onClose={handleCloseModal}
        timeline={timeline}
      />
      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </>
  );
};

export default Solicitacoes;
